import Theme from './theme';

export default class ThemeScene {
  themes: Theme[];

  constructor() {
    this.themes = [];
  }
}
